import * as api from "../api/auth";

class SignInError extends Error {
  constructor(message) {
    super();
    this.message = message;
  }
}

export const signin = async (formData) => {
  try {
    const { data } = await api.signin(formData);
    return data;
  } catch (error) {
    const { data } = error.response;
    return data;
  }
};

export const signup = async (formData) => {
  try {
    const { data } = await api.signup(formData);
    console.log("data from auth", data);
    return data;
  } catch (error) {
    const { data } = error.response;
    return data;
  }
};

export const verifyUser = async ({ id, token }) => {
  try {
    const { data } = await api.verifyUser({ id, token });
    console.log("The data", data);
    return data;
  } catch (error) {
    const { data } = error.response;
    return data;
  }
};
